import React from 'react';
import { Checkmark16, Time16 } from '@carbon/icons-react';
import { typicalWaitTimeFormatter } from 'utilities/formatters';

const ReferralTabLabel = ({
  referral,
  status
}: {
  referral: any;
  status: string;
}) => {
  return (
    <div className="mobile-view-tab-label">
      <div className="mobile-view-tab-icon">
        {status === 'COMPLETED' ? (
          <Checkmark16
            fill="#24A148"
            className="mobile-view-tab-icon-element"
          />
        ) : (
          <Time16 className="mobile-view-tab-icon-element" />
        )}
      </div>
      <div className="mobile-view-tab-content">
        <div className="mobile-view-tab-name">{referral.name}</div>
        {status === 'WAITING' && (
          <div className="mobile-view-tab-wait-time">
            Typical wait {typicalWaitTimeFormatter(referral?.waittime, true)}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferralTabLabel;
